import { render, staticRenderFns } from "./SOX.vue?vue&type=template&id=2dcb7d1d"
import script from "./SOX.vue?vue&type=script&lang=js"
export * from "./SOX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports